import React, { useState } from 'react'
import { MapContext, DriverLocation } from '../../../context/MapContext'
import { Point, PointInput } from '../../../__generated__/types'
import { useCompletePointGeoMutation } from './__generated__/points'

export const MapProvider = ({ children }: { children: JSX.Element }) => {
    const [points, updatePoints] = useState<Point[]>([])
    const [route, setRoute] = useState<GeoJSON.FeatureCollection | null>(null)
    const [distance, setDistance] = useState<number>(0)
    const [driverLocation, setDriverLocation] = useState<DriverLocation | null>(
        null
    )

    const [completePointGeo] = useCompletePointGeoMutation()

    const addPointByCoords = (coords: [number, number]) => {
        const point: PointInput = {
            longitude: coords[0],
            latitude: coords[1],
            sort: points.length
        }

        completePointGeo({
            variables: {
                input: point
            }
        })
            .then((data) => data.data?.fillPointGeo)
            .then((value) =>
                value &&
                updatePoints((points) => [
                    ...points,
                    { ...value, sort: points.length }
                ])
            )
    }

    const addPointByAddress = (point: Point) => {
        updatePoints((points) => [
            ...points,
            { ...point, sort: points.length }
        ])
    }

    const removePoint = (point: Point) => {
        updatePoints((points) => {
            if (points.length <= 1) {
                return []
            }
            const index = points.findIndex((p) => p.sort === point.sort)
            if (index === -1) {
                return points
            }
            const next = points.slice()
            next.splice(index, 1)
            return next.map((p, i) => ({ ...p, sort: i }))
        })
    }

    const updateOrderPoints = (newPoints: Point[]) => {
        updatePoints(newPoints)
    }

    const mapContext = {
        points,
        route,
        setRoute,
        distance,
        setDistance,
        driverLocation,
        setDriverLocation,
        addPointByCoords,
        addPointByAddress,
        removePoint,
        updateOrderPoints
    }
    return (
        <MapContext.Provider value={mapContext}>{children}</MapContext.Provider>
    )
}
